import GetAppButtons from "../GetAppButtons"
import BodyDefault from "../text/BodyDefault"
import Heading2 from "../text/Heading2"

export default function CallToActionBanner() {
  return (
    <>
      <div className="relative bg-purple isolate overflow-hidden py-[4rem] md:p-[4rem] text-center rounded-xl">
        <Heading2 className="text-white">Download de app</Heading2>
        <BodyDefault className="mx-auto px-[1rem] pt-[1.5rem] md:pb-[2rem] md:max-w-3xl text-white font-bold text-[1rem] leading-1.5">
          Ontdek jouw nieuwe manier van doneren, vanaf nu doneer je nooit meer anders.
        </BodyDefault>
        <div className="px-[0.3rem]">
          <GetAppButtons />
        </div>
      </div>
    </>
  )
}
